import { enabledColumn, GridColumn, scopeColumns } from './OverrideScopeColumns'

const disableOverridesColumns: GridColumn[] = [...scopeColumns, enabledColumn]

export default disableOverridesColumns
